import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "./assets/font-awesome/css/all.min.css";
import "./assets/css/config.css";
import "./assets/css/common.css";
import "./assets/css/style.css";
import "@arco-design/web-react/dist/css/arco.css";
import enUS from '@arco-design/web-react/es/locale/en-US';
import Login from "./Screens/Login/Login";
import Home from "./Screens/Home/Home";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "../src/globalData/constant";
import { routeList } from "../src/globalData/constant";
import { useEffect, useState } from "react";
import {
  combineAllRoutes,
  filterRouteData,
  getCookie,
  getLocalStorage,
  setLocalStorage,
} from "./Functions/Utils";
import AdminScreen from "./Screens/AdminScreens/AdminScreen";
import { ConfigProvider } from "@arco-design/web-react";
import { ManageApis } from "./AppServices/ManageApi";
import Dashboard from "./Screens/Dashboard/Dashboard";
import GlobalStateProvider, { useStoreValues } from "./Context/storeProvider";
import RouterComponent from "./Components/RouteComponent/Router";
function App() {





  useEffect(() => {
    window.addEventListener('error', e => {
      if (e.message === 'ResizeObserver loop completed with undelivered notifications.' ||
        e.message === 'ResizeObserver loop limit exceeded') {
        e.stopImmediatePropagation();
        e.preventDefault()
        // document.querySelector(`#webpack-dev-server-client-overlay`).style.display = 'none'
        const overlay = document.querySelector(`#webpack-dev-server-client-overlay`);
        if (overlay) {
          overlay.style.display = 'none';
        }
      }
    })
  }, [])

  // let tokent =document.cookie
  // //console.log("---------------->",getCookie("ueserRoll"))

  useEffect(() => {
    if (getCookie("ueserRoll") == "") {

    }

  }, [])






  return (
    <GlobalStateProvider >
      <ConfigProvider locale={enUS}>

        <RouterComponent />
      </ConfigProvider>
    </GlobalStateProvider>
  );
}

export default App;
